import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class CreateUpdateFlightAPICommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  ICreateUpdateFlightAPIParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'flights/integrationApi';
  public override setParameters(parameters: ICreateUpdateFlightAPIParameters) {
    this._commandBody = parameters;
  }
}

export interface ICreateUpdateFlightAPIParameters extends ICommandParameters {
  carrierAccountId: number;
  contractorAccountId: null;
  applicationName: string;
  description: string;
  userName: string;
  password: string;
  enabled: boolean;
  blocked: boolean;
}
